module.exports = __webpack_public_path__ + "img/sahnma.b47d76bd.png";